import { getToolState } from 'app/CornerstoneTools';
import { IBaseAnnotationTool } from 'cornerstone-tools';

/**
 * Filters an array of tools, returning only tools which have annotation data.
 */
export default function getToolsWithDataForElement<T>(
  element: HTMLElement,
  tools: IBaseAnnotationTool[]
): IBaseAnnotationTool[] {
  return tools.filter((tool) => {
    const toolState = getToolState<T>(element, tool.name);

    return toolState && toolState.data.length > 0;
  });
}
